export enum PermissionTypeEnum {
  VisualizacaoExames = '5',
  VisualizacaoConsultas = '10',
  SmsNotificacoes = '9'
}